import React from "react";
import { Activity, BarChart3, Flame, Trophy } from "lucide-react";
import ProfileSectionCard from "../components/ProfileSectionCard";
import { useProfileHub } from "../ProfileHubContext";

export default function ProfileStatsSection() {
  const { profileIdentity, summary } = useProfileHub();

  const statCards = [
    {
      label: "Score total",
      value: profileIdentity.total_score,
      icon: BarChart3,
    },
    {
      label: "Parties jouees",
      value: profileIdentity.games_played,
      icon: Activity,
    },
    {
      label: "Best score",
      value: profileIdentity.best_score,
      icon: Flame,
    },
    {
      label: "Average score",
      value: profileIdentity.average_score || 0,
      icon: Trophy,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {statCards.map((card) => {
          const Icon = card.icon;

          return (
            <ProfileSectionCard key={card.label} className="bg-[linear-gradient(145deg,#ffffff,#eff6ff)]">
              <div className="flex items-center justify-between gap-3">
                <div>
                  <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
                    {card.label}
                  </div>
                  <div className="mt-2 text-3xl font-semibold text-slate-950">
                    {card.value}
                  </div>
                </div>
                <div className="rounded-2xl bg-slate-950 p-3 text-white">
                  <Icon className="h-5 w-5" />
                </div>
              </div>
            </ProfileSectionCard>
          );
        })}
      </div>

      <div className="grid gap-6 lg:grid-cols-[1fr,1fr]">
        <ProfileSectionCard
          title="Stats de performance"
          subtitle="Quelques indicateurs simples deja exploitables a partir des parties sauvegardees."
        >
          <div className="grid gap-3 sm:grid-cols-3">
            <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4">
              <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
                Top 1
              </div>
              <div className="mt-2 text-2xl font-semibold text-slate-950">
                {summary.wins}
              </div>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4">
              <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
                Parties comptabilisees
              </div>
              <div className="mt-2 text-2xl font-semibold text-slate-950">
                {summary.rankedGames}
              </div>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4">
              <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
                Best finish
              </div>
              <div className="mt-2 text-2xl font-semibold text-slate-950">
                {summary.bestFinish || "-"}
              </div>
            </div>
          </div>
        </ProfileSectionCard>

        <ProfileSectionCard
          title="Categories les plus rentables"
          subtitle="Base simple pour rendre les stats plus vivantes meme avant un vrai module analytics."
        >
          <div className="space-y-3">
            {summary.topCategories.length === 0 ? (
              <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-sm text-slate-500">
                Pas encore assez de parties pour produire des stats categorie.
              </div>
            ) : (
              summary.topCategories.slice(0, 5).map((item) => (
                <div
                  key={item.category}
                  className="flex items-center justify-between rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3"
                >
                  <div>
                    <div className="font-semibold text-slate-900">{item.category}</div>
                    <div className="mt-1 text-xs text-slate-500">
                      {item.games} parties - best {item.bestScore}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-lg font-semibold text-slate-900">
                      {item.totalScore}
                    </div>
                    <div className="text-[11px] uppercase tracking-[0.18em] text-slate-400">
                      total
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </ProfileSectionCard>
      </div>
    </div>
  );
}
